import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StpRegistrationStorageService } from '../../services/stp-registration-storage.service';

/**
 * Every correction request of an STP (new application, renewal or reapply) as a list, newest first: when,
 * for which application and the reason the admin wrote. Requests made before the reason was kept in the
 * history show "Reason not recorded"; with no saved history at all, the current reason is shown.
 */
@Component({
  selector: 'app-correction-history',
  template: `
    <ol *ngIf="history.length >= showFrom" class="mb-0 pl-3">
      <li *ngFor="let row of history; let i = index" class="mb-1">
        <b>{{ row.requestedAt | date: 'dd-MM-yyyy, h:mm a' }}</b>
        <span class="text-muted"> ({{ applicationOf(row.description) }})</span>
        <span *ngIf="i === 0 && current" class="badge badge-danger ml-1" style="font-size: 10px">Current</span>
        <div [innerText]="row.reason || 'Reason not recorded'"></div>
      </li>
    </ol>
    <span *ngIf="history.length === 0 && showFrom <= 1 && fallbackReason" [innerText]="fallbackReason"></span>
  `,
})
export class CorrectionHistoryComponent implements OnChanges {
  @Input() stpMainId: number | string | null | undefined;
  // the newest request is still waiting for the STP's correction
  @Input() current = false;
  // shown when there is no saved correction history (e.g. the current reason)
  @Input() fallbackReason: string | null | undefined;
  // smallest number of requests that shows the list (2 = only when there was more than one)
  @Input() showFrom = 1;

  history: any[] = [];

  constructor(private stpRegistrationStorageService: StpRegistrationStorageService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stpMainId'] && this.stpMainId) {
      this.stpRegistrationStorageService.getCorrectionHistory(Number(this.stpMainId)).subscribe({
        next: (res) => (this.history = Array.isArray(res?.data) ? res.data : []),
        error: () => (this.history = []),
      });
    }
  }

  applicationOf(description: string): string {
    const text = (description || '').toLowerCase();
    if (text.includes('re-apply')) {
      return 'Reapply';
    }
    return text.includes('renewal') ? 'Renewal' : 'Application';
  }
}
